<template>
    <div class="main-content" v-if="role">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h6>{{role.name}}</h6>
                    </div>
                    <div class="card-body">


                        <div v-if="!role.id">

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">Alias роли</label>
                                        <input class="form-control" type="text" name="role_name"
                                               v-validate="'required|alpha:en-US|min:4|max:255'"
                                               data-vv-as="Alias роли"
                                               placeholder="Alias роли"
                                               v-model="role.name">
                                        <small class="form-text text-danger" v-if="errors.has('role_name')">
                                            {{ errors.first('role_name') }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">Наименование роли (русский)</label>
                                        <input class="form-control" type="text" name="role_name_title"
                                               v-validate="'required|min:4|max:255'"
                                               data-vv-as="Наименование роли (русский)"
                                               placeholder="Наименование роли"
                                               v-model="role.name_title">
                                        <small class="form-text text-danger" v-if="errors.has('role_name_title')">
                                            {{ errors.first('role_name_title') }}
                                        </small>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div v-if="role.id" class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="">Новый доступ</label>
                                    <input class="form-control" type="text" name="permit_name"
                                           v-validate="{required:true,regex:/^[0-9A-Za-z\/]+$/,min:3,max:255}"
                                           data-vv-as="Alias доступа"
                                           placeholder="Alias доступа"
                                           v-model="permission.name">
                                    <small class="form-text text-danger" v-if="errors.has('permit_name')">
                                        {{ errors.first('permit_name') }}
                                    </small>
                                    <button class="btn btn-success m-t-10" @click="updateRole('permit')">Добавить
                                    </button>
                                </div>
                            </div>
                        </div>


                        <table class="table table-hover table-sm table-striped">
                          <thead>
                          <tr>
                            <th></th>
                            <th>ID</th>
                            <th>Доступ</th>
                            <th>Дата создания</th>
                            <th></th>
                          </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(record, index) in permissions">
                                <td>{{(index + 1) + ((paginator.current_page - 1) * paginator.per_page)}}</td>
                                <td>{{record.id}}</td>
                                <td>{{record.name}}</td>
                                <td>{{record.created_at}}</td>
                                <td><input v-model="selected_permissions[record.id]" type="checkbox"></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="text-right">

                            <vue-ladda @click="updateRole" button-class="btn btn-success f-l" data-style="zoom-in"
                                       :loading="btn_role_update_loading">Сохранить
                            </vue-ladda>

                            <paginate v-if="paginator"
                                      :page-count="paginator.last_page"
                                      :page-range="3"
                                      :margin-pages="2"
                                      :click-handler="getPermitions"
                                      :prev-text="'&laquo'"
                                      :next-text="'&raquo'"
                                      :container-class="'pagination'"
                                      :prev-class="'page-item'"
                                      :prev-link-class="'page-link'"
                                      :page-class="'page-item'"
                                      :page-link-class="'page-link'"
                                      :next-class="'page-item'"
                                      :next-link-class="'page-link'"
                                      :active-class="'active green_btn'">
                            </paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .text-rigth {
        padding-right: 10px;
    }

    .pagination {
        justify-content: flex-end;
    }

    a.btn {
        cursor: pointer;
        color: white;
    }

    a.btn:hover {
        color: white;
    }

    .m-t-10 {
        margin-top: 10px;
    }

    .f-l {
        float: left
    }

    .btn.ladda-button {
        padding: 2px 17px;
    }

    .btn-info.ladda-button {
        background-color: #5BBFDE;
    }

    .btn-success.ladda-button {
        background-color: #4fc47f;
    }

</style>

<script>
    import api from '@/api'
    import Paginate from 'vuejs-paginate'
    import VueLadda from 'vue-ladda/src/vue-ladda.vue'

    export default {
        components: {
            Paginate,
            VueLadda
        },
        data() {
            return {
                role: null,
                permission: {},
                permissions: {},
                paginator: null,
                selected_permissions: {},
                btn_role_update_loading: false
            }
        },
        mounted() {
            this.getPermitions();
            this.getRole()
        },
        methods: {
            isInputsValid: function (inputs) {

                return Promise.all(inputs.map(input => this.$validator.validate(input)))
                    .then((results) => {
                        const hasErrors = results.indexOf(false) !== -1;
                        return Promise.resolve(!hasErrors);
                    });

            },
            async getRole() {
                if (this.$route.params.id !== 'new') {
                    let {data} = await api.index('/settings/getRoles?id=' + this.$route.params.id);
                    this.role = data.role;
                    this.role.permissions.forEach((perm) => {
                        this.selected_permissions[perm.id] = true
                    })
                } else {
                    this.role = {
                        permissions: {}
                    }
                }

            }
            ,
            async getPermitions(page = null) {
                let {data: r_data} = await api.index('/settings/getPermissions?page=' + page);
                const {data, ...pagination} = r_data.permissions;
                this.paginator = pagination;
                this.permissions = data
            }
            ,
            async updateRole(permit = false) {
                var valid = true;
                if (permit === 'permit') {
                    valid = await this.isInputsValid(['permit_name']);
                }
                if (!this.role.id && !permit) {
                    valid = await this.isInputsValid(['role_name_title', 'role_name']);
                }

                if (!valid) return;

                this.btn_role_update_loading = true;
                let {data} = await api.store('/settings/updateRole', {
                    role_id: this.$route.params.id,
                    role: this.role,
                    permit: permit,
                    permission: this.permission,
                    selected_permissions: this.selected_permissions
                });
                if (data.success) {
                    toastr['success']('Обновлено', 'Успешно!');
                    if (permit) this.getPermitions();
                } else {
                    toastr['warning'](data.message, 'Ошибка!')
                }
                this.btn_role_update_loading = false
            }
        }
    }

</script>
